// 账号管理账户角色
export const accountRole = {
  // 一般广告主
  ROLE_ADVERTISER: 0,
  // 广告代理商
  ROLE_AGENT: 1,
  // 虚拟广告主
  ROLE_VIRTAUL_ADVERTISER: 2,
  // 管理员
  ROLE_ADMIN: 3,
  // 内部广告主
  ROLE_INTERNAL_ADV: 4,
  // 二级代理商
  ROLE_CHILD_AGENT: 6,
  // 头条号文章作者
  ROLE_PGC_ADVERTISER: 7,
  // 头条自建DSP广告主
  ROLE_DSP_ADVERTISER: 8,
  // 账号管家
  ROLE_MAJORDOMO: 13,
  // 自助客户
  ROLE_SLEF_ACCOUNT: 104,
  // 直客
  ROLE_COMMON_ACCOUNT: 101,
  // 代理商创建虚客
  ROLE_VIRTAUL_ACCOUNT: 103,
};
// 账号管理账号状态
export const advertiserStatus = {
  // 已禁用
  DISABLE: 0,
  // 待审核
  PENDING_CONFIRM: 1,
  // 待验证
  PENDING_VERIFIED: 2,
  // 审核失败/可再次申请
  CONFIRM_FAIL: 3,
  // 已审核
  ENABLE: 4,
  // 审核失败/最终状态
  CONFIRM_FAIL_END: 5,
  // 修改审核
  PENDING_CONFIRM_MODIFY: 6,
  // 修改审核失败
  CONFIRM_MODIFY_FAIL: 7,
  // 惩罚
  PUNISH: 8,
  // 等待CRM审核
  WAIT_FOR_BPM_AUDIT: 9,
  // 推广自助开户
  PROMOTION_SELF_SERVICE: 10,
  // SMB客户
  STATUS_WAIT_FOR_BPM_FILE_CONTACT: 12,
  // SMB待缴费
  STATUS_WAIT_FOR_ACCOUNT_FEE: 13,
  // 待对公验证
  STATUS_WAIT_FOR_PUBLIC_AUTH: 14,
  // 合约未生效
  STATUS_CONTACT_PENDING: 15,
};
// 账号管理营销区域
export const promotionArea = {
  NATIONAL: 1,
  LOCAL: 2,
};

// 账号管理-消息中心-消息显示选项
export const notificationViewOption = {
  // 全部消息
  ALL: 0,
  // 管理员消息
  ADMIN: 1,
  // 系统消息
  SYSTEM: 2,
};
// 账号管理-消息中心-消息类型
export const notificationType = {
  // 系统广播
  SYSTEM_BC: 1,
  // 广告主广播
  ADVERTISER_BC: 2,
  // 代理广播
  AGENT_BC: 3,
  // 管理员广播
  ADMIN_BC: 4,
  // 系统消息
  SYSTEM_DM: 5,
  // 自动dm都用这个作为key
  AUTO_DM: 6,

  // 广告审核通过
  AD_AUDIT_SUCCESS: 101,
  // 广告审核不通过
  AD_AUDIT_REJECT: 102,
  // 广告接近预算 - 作废 mapeng
  AD_PRE_OFFLINE_BUDGET: 103,
  // 广告超出预算
  AD_OFFLINE_BUDGET: 104,
  // 广告因账号余额不足暂停
  AD_OFFLINE_BALANCE: 105,
  // 新的广告接近预算
  AD_PRE_OFFLINE_BUDGET_NEW: 106,

  // 管理员充值
  ADMIN_RECHARGE: 201,
  // 在线充值成功
  ONLINE_RECHARGE: 202,
  // 代理充值
  AGENT_RECHARGE: 203,
  // 代理退款
  AGENT_REFUND: 204,

  // 广告组接近预算 - 作废 mapeng
  CAMPAIGN_PRE_OFFLINE_BUDGET: 301,
  // 广告组超出预算
  CAMPAIGN_OFFLINE_BUDGET: 302,
  // 新的广告组接近预算
  CAMPAIGN_PRE_OFFLINE_BUDGET_NEW: 303,

  // 广告主赠款
  GRANT_RECHARGE: 401,
  // 广告主补偿款
  COMPENSATE_RECHARGE: 402,
  // 广告主余额低于
  PRE_OFFLINE_BALANCE: 403,

  // 广告主审核通过
  ADV_AUDIT_SUCCESS: 501,
  // 广告主审核不通过
  ADV_AUDIT_REJECT: 502,
  // 广告主禁用
  ADV_AUDIT_DISABLE: 503,
  // 广告计划转换ID填错
  CONVERT_ID_DISABLE: 601,
  // CPA广告主反作弊策略
  ADVERTISER_CPA_CHEATING_MIN: 701,
  ADVERTISER_CPA_CHEATING_MAX: 800,
  // 附加创意建站页面修改
  TETRIS_ADDTION_FIX: 1001,
  VIDEO_CONVERT_INFO: 1300,
  // 抖音审核失败
  AD_AWEME_AUDIT_REJECT: 107,
};

export const SwitchLang = 'switchLang'; // event switch lang key

export const AccountStatusKeys = {
  0: 'common_status_disabled', // 已禁用
  1: 'common_status_for_check', // 待审核
  2: 'common_status_for_verify', // 待验证
  3: 'common_status_check_fail', // 审核失败
  4: 'common_status_check_success', // 审核成功
  5: 'common_status_check_fail_end', // 审核失败/最终状态
  6: 'common_status_modify_audit', // 修改审核中
  7: 'common_status_modify_audit_fail', // 修改审核失败
  8: 'common_status_punish', // 惩罚
  9: 'common_status_bpm_audit', // 等待CRM审核
  10: 'common_status_self_unaudited', // 自助开户待验证资质
  11: 'common_status_avatar_auditing', // 头像审核中
  12: 'common_status_bpm_file_contact', // SMB客户待合同归档
  13: 'common_status_account_fee', // SMB广告主待缴纳开户费
  14: 'common_status_public_auth', // 待对公身份验证
  15: 'common_status_advertiser_contact_pending', // 合同未生效
};

export const QualificationSource = {
  NOT_FROM_BC: 0,
  BC: 1, // 来自bc
};

export const accountType = {
  // 未定义
  NO_SET: 0,
  // 品牌用户
  RESERVATION: 1,
  // 竞价用户
  AUCTION: 2,
};

// TTP 打标枚举
export const regionType = {
  TTP: 1,
  NON_TTP: 2,
};


export const invoicePresentMap = {
  REQUIRED: 1, // 必填，展示
  RECOMMEND: 2, // 推荐填写，展示
  HIDE: 3, // 不展示
};

export const QualificationType = {
  0: 'description', // 广告主推广描述资质
  1: 'license', // 营业执照
  2: 'qualification', // 其他开户资质
  3: 'adQualification', // 投放资质 非中国区无此字段，同步
  4: 'sezQualification', // 国际化自助广告主sez税号，只有印度地区用到
  10: 'musicQualification', // 音乐资质
  11: 'medicineQualification', // 药品资质
};

export const quailficationRejectReasonType = {
  MUSIC: 19, // 音乐资质类 拒审理由
};

export const qualificationImgsType = 2; // 资质图片的type，和上面的2是一样的

export const QualificationStatus = {
  audit: 0, // 审核中
  reject: 1, // 拒绝
  success: 2, // 审核通过
};

// 资质类别
export const qualificationCategory = {
  musicQualification: 10, // 音乐资质
  medicineQualification: 11, // 药品资质
};

// 药品资质接口参数格式
export const medicineQualificationParams = {
  starling_namespace: 'module', // starling命名空间
  starling_project: 'TikTok_Ads', // starling项目
  category: qualificationCategory.medicineQualification, // 医药资质写死11
  pictures: [],
  content_fields: {
    country_codes: {
      label: 1, // 写死，用于字段标记
      starling_key: 'module_account_qualification_industrial_formitem_country', // 前端的多语言翻译key
      contents: [],
    },
    certification_number: {
      label: 2,
      starling_key: 'module_account_medical_certification_number',
      contents: [],
    },
    qualification_name: {
      label: 3,
      starling_key: 'module_account_medicine_name',
      contents: [],
    },
    certification_url: {
      label: 4,
      starling_key: 'module_account_medical_certification_url',
      contents: [],
    },
    supplement_info: {
      label: 5,
      starling_key: 'module_account_qualification_certification_info',
      contents: [],
    },
  },
};

export const billStatus = {
  SUCCESS: 0,
  FAILED: -501302,
  PROCESSING: -501301,
};

// 自助客户升级直客客户的状态
export const upgradeStatus = {
  NO_PROCESS: 0, // 默认
  WAIT_USER_SIGN: 1, // 等待用户签署
  DURING_UPGRADE: 2, // 升级中
  UPGRADE_FAILED: 3, // 升级失败
  UPGRADE_SUCCESS: 4, // 升级成功
};

export const EU_ISO_LIST = [
  'AX',
  'AL',
  'AD',
  'AT',
  'BY',
  'BE',
  'BA',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FO',
  'FI',
  'FR',
  'DE',
  'GI',
  'GR',
  'GG',
  'VA',
  'HU',
  'IS',
  'IE',
  'IM',
  'IT',
  'JE',
  'LV',
  'LI',
  'LT',
  'LU',
  'MT',
  'MD',
  'MC',
  'ME',
  'NL',
  'MK',
  'NO',
  'PL',
  'PT',
  'RO',
  'RU',
  'SM',
  'RS',
  'SK',
  'SI',
  'ES',
  'SJ',
  'SE',
  'CH',
  'UA',
  'GB',
];

export const STATE_GEOID = {
  HAWAII: 5855797,
  WEST_VIRGINIA: 4826850,
  NEW_MEXICO: 5481136,
};
